<template>
  <div class="content">
    <div class="storeContent">
        <img :src="$t('store.banner[0]')">
        <div class="storeList">
            <div class="storeItem" v-for="(item,index) in storeList" :key="index" :class="index != storeList.length-1 ? 'mr_20':''" @mouseenter="storeViewIndex = index" @mouseleave="storeViewIndex = ''" @click="storeJump(item)">
                <img :src="lang == 'zh'?item.picturesZhCn[0]:(item.picturesEnUs[0]?item.picturesEnUs[0]:item.picturesZhCn[0])">
                <p :class=" $vuetify.breakpoint.mobile ? 'ft_12':''">{{ lang == 'zh' ? item.contentNameZhCn : (item.contentNameEnUs?item.contentNameEnUs:item.contentNameZhCn)}}</p>
                <div v-show="storeViewIndex === index" class="viewCode">
                    <img :src="lang == 'zh'?item.picturesZhCn[1]:(item.picturesEnUs[1]?item.picturesEnUs[1]:item.picturesZhCn[1])">
                </div>
            </div>
        </div>
    </div>
    <div class="storeMore">
        <img :src="$t('store.banner[1]')">
    </div>
  </div>
</template>

<script>
import storeApi from '../../api/store'
import channelApi from '../../api/channels'
import izh from "../../i18n/zh";
import ien from "../../i18n/en";
  export default {
    name: 'store',
    data: () => ({
        storeList: [],
      storeViewIndex:''
    }),
    computed:{
        lang(){
            return this.$i18n.locale;
        }
    },
    methods:{
        async getData(){
            let { data: bannerData } = await storeApi.getBanner();
            let bannerDataList = bannerData[0].contents;
            bannerDataList.forEach(item => {
                izh.store.banner.push(item.picturesZhCn);
                ien.store.banner.push(item.picturesEnUs ? item.picturesEnUs:item.picturesZhCn);
            });
            let { data: storeData } = await channelApi.getStoreList();
            let storeAllList = storeData[0].children.length>0 ? storeData[0].children : [];
            this.storeList = [];
            storeAllList.forEach(item=>{
                if( item.children.length>0 && item.children[2]&&item.children[2].contents&&item.children[2].contents.length>0){
                    this.storeList.push( { 
                        sectionCode: item.sectionCode,
                        contentNameZhCn: item.children[2].contents[0].contentNameZhCn,
                        contentNameEnUs: item.children[2].contents[0].contentNameZhCn,
                        picturesZhCn: item.children[2].contents[0].picturesZhCn ? item.children[2].contents[0].picturesZhCn.split(','):'',
                        picturesEnUs: item.children[2].contents[0].picturesEnUs ? item.children[2].contents[0].picturesEnUs.split(','):'',
                     } )
                }
            })
        },
        storeJump(item){
            this.$router.push( {path:'/channels',query:{ sectionCode: item.sectionCode }})
        }
    },
    mounted(){
        this.getData();
    }
  }
  
</script>
<style lang="scss" scoped>
    .storeContent{
        width: 100%;
        position: relative;
        img{
            width: 100%;
            display: block;
        }
    }
    .storeList{
        width: 100%;
        height: 20%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        position: absolute;
        bottom: 5%;
        left: 0;
        .mr_20{
            margin-right: 20px;
        }
        .storeItem{
            // flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            position: relative;
            img{
                height: 7.55rem;
                width: 7.55rem;
                border-radius: 50%;
                // object-fit: fill;
            }
            p{
                color: #000;
                font-size: 25px;
                text-align: center;
                font-weight: bold;
            }
            .ft_12{
                font-size: 12px;
            }
        }
        .viewCode{
            position: absolute;
            top: -140%;
            width: 13rem;
            height: 14rem;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: url('../../assets/images/QR.png');
            background-position: center;
            background-size: 100%;
            img{
                border-radius: 0;
                width: 10rem;
                height: 10rem;
            }
        }
    }
    .storeMore{
        width: 100%;
        margin-top: -6px;
        img{
            width: 100%;
        }
    }
</style>
